import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const MapPlusIcon = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="map-outline"
          d="M14 4.764C13.69 4.764 13.384 4.692 13.106 4.553L8.894 2.447C8.617 2.308 8.311 2.236 8 2.236M14 4.764C14.311 4.764 14.617 4.692 14.894 4.553L18.553 2.723C18.706 2.647 18.875 2.611 19.046 2.618C19.216 2.626 19.382 2.677 19.527 2.767C19.672 2.857 19.791 2.982 19.874 3.131C19.957 3.281 20.001 3.448 20 3.619V10.001V13.192M14 4.764V19.764M14 19.764C13.69 19.764 13.384 19.693 13.106 19.554L8.894 17.448C8.617 17.309 8.311 17.237 8 17.237C7.689 17.237 7.384 17.309 7.106 17.448L3.447 19.278C3.295 19.354 3.125 19.39 2.955 19.382C2.784 19.375 2.619 19.324 2.474 19.233C2.328 19.143 2.209 19.018 2.126 18.869C2.043 18.719 1.999 18.552 2 18.381V5.618C2.001 5.432 2.052 5.25 2.15 5.092C2.248 4.934 2.387 4.807 2.553 4.724L7.106 2.447C7.384 2.308 7.689 2.236 8 2.236M8 2.236V17.236"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          key="plus-symbol"
          d="M17 20H23M20 17V23"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

MapPlusIcon.displayName = "MapPlusIcon"

export const MapPlusIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.8,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path key="map-center-fill" d="M14 4.764V19.764" fill="currentColor" />
        <path
          key="map-left-fill"
          d="M8 2.236L13.603 4.724L13.5 14.5L13.106 18.869L8 17.236"
          fill="currentColor"
        />
        <path
          key="map-outline"
          d="M14 4.764C13.69 4.764 13.384 4.692 13.106 4.553L8.894 2.447C8.617 2.308 8.311 2.236 8 2.236M14 4.764C14.311 4.764 14.617 4.692 14.894 4.553L18.553 2.723C18.706 2.647 18.875 2.611 19.046 2.618C19.216 2.626 19.382 2.677 19.527 2.767C19.672 2.857 19.791 2.982 19.874 3.131C19.957 3.281 20.001 3.448 20 3.619V10.001V13.192M14 4.764V19.764M14 4.764L14 19.764M14 19.764C13.69 19.764 13.384 19.693 13.106 19.554L8.894 17.448C8.617 17.309 8.311 17.237 8 17.237C7.689 17.237 7.384 17.309 7.106 17.448L3.447 19.278C3.295 19.354 3.125 19.39 2.955 19.382C2.784 19.375 2.619 19.324 2.474 19.233C2.328 19.143 2.209 19.018 2.126 18.869C2.043 18.719 1.999 18.552 2 18.381V5.618C2.001 5.432 2.052 5.25 2.15 5.092C2.248 4.934 2.387 4.807 2.553 4.724L7.106 2.447C7.384 2.308 7.689 2.236 8 2.236M8 2.236L13.603 4.724L13.5 14.5L13.106 18.869L8 17.236"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          key="plus-symbol"
          d="M17 20H23M20 17V23"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

MapPlusIconActive.displayName = "MapPlusIconActive"
